// extracted by mini-css-extract-plugin
module.exports = {"LoadingPage":"styles_LoadingPage__i7HVr","loader":"styles_loader__DTJGj"};